import { Injectable, inject } from '@angular/core';
import { EFeatureFlags } from '@app/shared/enums/feature-flag';
import { environment } from '@environments/environment';
import { AuthService } from '@shared/services/auth/auth.service';

export const MapFeaturePermissions = {
  'cost-centers': EFeatureFlags.COST_CENTERS,
  organizations: EFeatureFlags.ORGANIZATIONS,
  items: EFeatureFlags.ITEM_CATALOG,
  'purchase-orders': EFeatureFlags.EXTERNAL_PO,
  'user-groups': EFeatureFlags.USER_GROUPS,
  'crib-groups': EFeatureFlags.CRIB_GROUPS,
  restrictions: EFeatureFlags.RESTRICTIONS,
  suppliers: EFeatureFlags.SUPPLIERS,
  scheduling: EFeatureFlags.SCHEDULING,
  bins: EFeatureFlags.BINS,
  cribs: EFeatureFlags.CRIBS,
  users: EFeatureFlags.USERS,
  customers: EFeatureFlags.CUSTOMERS,
};

const MapEnvironmentsFeatureFlags = {
  Local: [
    EFeatureFlags.BINS,
    EFeatureFlags.COST_CENTERS,
    EFeatureFlags.CRIBS,
    EFeatureFlags.CRIB_GROUPS,
    EFeatureFlags.CUSTOMERS,
    EFeatureFlags.DURABLE_RETURNS,
    EFeatureFlags.EXTERNAL_PO,
    EFeatureFlags.INSIGHTS,
    EFeatureFlags.ITEM_CATALOG,
    EFeatureFlags.ORGANIZATIONS,
    EFeatureFlags.RESTRICTIONS,
    EFeatureFlags.SCHEDULING,
    EFeatureFlags.SUPPLIERS,
    EFeatureFlags.USERS,
    EFeatureFlags.USER_GROUPS,
  ],
  Development: [
    EFeatureFlags.BINS,
    EFeatureFlags.COST_CENTERS,
    EFeatureFlags.CRIBS,
    EFeatureFlags.CRIB_GROUPS,
    EFeatureFlags.CUSTOMERS,
    EFeatureFlags.DURABLE_RETURNS,
    EFeatureFlags.EXTERNAL_PO,
    EFeatureFlags.INSIGHTS,
    EFeatureFlags.ITEM_CATALOG,
    EFeatureFlags.ORGANIZATIONS,
    EFeatureFlags.RESTRICTIONS,
    EFeatureFlags.SCHEDULING,
    EFeatureFlags.SUPPLIERS,
    EFeatureFlags.USERS,
    EFeatureFlags.USER_GROUPS,
  ],
  Production: [
    EFeatureFlags.BINS,
    EFeatureFlags.COST_CENTERS,
    EFeatureFlags.CRIBS,
    EFeatureFlags.CRIB_GROUPS,
    EFeatureFlags.DURABLE_RETURNS,
    EFeatureFlags.EXTERNAL_PO,
    EFeatureFlags.INSIGHTS,
    EFeatureFlags.ITEM_CATALOG,
    EFeatureFlags.ORGANIZATIONS,
    EFeatureFlags.RESTRICTIONS,
    EFeatureFlags.SCHEDULING,
    EFeatureFlags.SUPPLIERS,
    EFeatureFlags.USERS,
    EFeatureFlags.USER_GROUPS,
  ],
  QA: [
    EFeatureFlags.BINS,
    EFeatureFlags.COST_CENTERS,
    EFeatureFlags.CRIBS,
    EFeatureFlags.CRIB_GROUPS,
    EFeatureFlags.DURABLE_RETURNS,
    EFeatureFlags.EXTERNAL_PO,
    EFeatureFlags.INSIGHTS,
    EFeatureFlags.ITEM_CATALOG,
    EFeatureFlags.ORGANIZATIONS,
    EFeatureFlags.RESTRICTIONS,
    EFeatureFlags.SCHEDULING,
    EFeatureFlags.SUPPLIERS,
    EFeatureFlags.USERS,
    EFeatureFlags.USER_GROUPS,
  ],
  Staging: [
    EFeatureFlags.BINS,
    EFeatureFlags.COST_CENTERS,
    EFeatureFlags.CRIBS,
    EFeatureFlags.CRIB_GROUPS,
    EFeatureFlags.DURABLE_RETURNS,
    EFeatureFlags.EXTERNAL_PO,
    EFeatureFlags.INSIGHTS,
    EFeatureFlags.ITEM_CATALOG,
    EFeatureFlags.ORGANIZATIONS,
    EFeatureFlags.RESTRICTIONS,
    EFeatureFlags.SCHEDULING,
    EFeatureFlags.SUPPLIERS,
    EFeatureFlags.USERS,
    EFeatureFlags.USER_GROUPS,
  ],
};

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  private authService = inject(AuthService);

  evaluate(featureFlagModule: EFeatureFlags): boolean {
    // VALIDATE IF USER HAS FEATURE FLAG ENABLED
    if (!featureFlagModule) return true;

    return MapEnvironmentsFeatureFlags[environment.name]?.some((module) => module === featureFlagModule) ?? true;
  }

  filterByFeatureFlags(rows: Array<any>) {
    const permissionsOnCache = this.authService.getOrgPermissionsFromCache();
    const filteredByFeatureFlag = rows.filter((row) => this.evaluate(row.featureFlag));
    const filteredByPermissionsOnCache = filteredByFeatureFlag.filter(({ permissions }) =>
      permissions.some((value) => permissionsOnCache.includes(value.key))
    );
    return filteredByPermissionsOnCache;
  }
}
